import { render, staticRenderFns } from "./RouteCalculator.vue?vue&type=template&id=20f37a98&"
import script from "./RouteCalculator.vue?vue&type=script&lang=ts&"
export * from "./RouteCalculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports